(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8038],{

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 9701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[slug]",
      function () {
        return __webpack_require__(75049);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atomic/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(96526);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/atomic/Breadcrumbs/Breadcrumbs.js







var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _hasMaxWidth = param.hasMaxWidth, hasMaxWidth = _hasMaxWidth === void 0 ? false : _hasMaxWidth;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: breadcrumbs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    children: '\n              {\n                "@context": "https://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": ['.concat(breadcrumbs.map(function(breadcrumb, index) {
                        return JSON.stringify({
                            "@type": "ListItem",
                            position: "".concat(index + 1),
                            name: "".concat(breadcrumb.title),
                            item: "https://www.leaseloco.com".concat(breadcrumb.slug ? breadcrumb.slug : router.asPath.split("?")[0])
                        });
                    }), "]\n              }\n            ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "".concat((breadcrumbs_module_default()).list, " ").concat(hasMaxWidth ? (breadcrumbs_module_default())["has-max-width"] : ""),
                    children: breadcrumbs.map(function(crumb, index) {
                        if (!crumb.slug) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (breadcrumbs_module_default())["breadcrumb-item"],
                                "aria-current": "page",
                                children: crumb.title
                            }, crumb.title ? crumb.title : index);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumbs_module_default())["breadcrumb-item"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: crumb.slug,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: crumb.title
                                })
                            })
                        }, crumb.title ? crumb.title : index);
                    })
                })
            })
        ]
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: (prop_types_default()).array.isRequired,
    hasMaxWidth: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/Breadcrumbs/index.js



/***/ }),

/***/ 29099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atomic/PageContainer/PageContainer.tsx

var PageContainer = function(param) {
    var children = param.children, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: "container container--body ".concat(containerClass),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/atomic/PageContainer/index.ts



/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ChatWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/ChatWidget.tsx



var ChatWidget = function() {
    if (!(0,system/* isProd */.BB)() || !"0e82ae7a-23e7-4571-a768-93f6cea963b2") {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "ze-snippet",
        strategy: "lazyOnload",
        src: "https://static.zdassets.com/ekr/snippet.js?key=".concat("0e82ae7a-23e7-4571-a768-93f6cea963b2")
    });
};

;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/index.ts



/***/ }),

/***/ 75049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _components_atomic_Breadcrumbs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52321);
/* harmony import */ var _components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29099);
/* harmony import */ var _components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1429);
/* harmony import */ var _components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65299);
/* harmony import */ var _components_styleguide_Header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(638);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7158);










var Container = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8456), __webpack_require__.e(6388), __webpack_require__.e(5452)]).then(__webpack_require__.bind(__webpack_require__, 5452));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5452)
            ];
        }
    }
});
var FaqsArticlePage = function(param) {
    var article = param.article;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        {
            title: "Home",
            slug: _lib_routes__WEBPACK_IMPORTED_MODULE_9__/* .ROUTES.homePage.url */ .Z.homePage.url
        },
        {
            title: "FAQs",
            slug: _lib_routes__WEBPACK_IMPORTED_MODULE_9__/* .ROUTES.faqsPage.url */ .Z.faqsPage.url
        },
        {
            title: "".concat(article.title),
            slug: null
        }, 
    ]), breadcrumbs = ref[0];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (typeof window.ttq !== "undefined") {
            window.ttq.track("ViewContent", {
                /* eslint-disable */ content_id: "".concat(article.title),
                content_type: "product",
                content_name: "".concat(article.title),
                /* eslint-enable */ quantity: 1,
                value: null,
                price: null,
                currency: "GBP"
            });
        }
    }, [
        article.title
    ]);
    if (!article) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: "loading..."
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_PageMetaData__WEBPACK_IMPORTED_MODULE_6__/* .PageMetaData */ .S, {
                title: "".concat(article.title, " | FAQ | LeaseLoco"),
                description: article.metaDescription,
                pageUrl: router.asPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_ChatWidget__WEBPACK_IMPORTED_MODULE_7__/* .ChatWidget */ .A, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Header__WEBPACK_IMPORTED_MODULE_8__/* .Header */ .h, {
                backgroundColor: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atomic_PageContainer__WEBPACK_IMPORTED_MODULE_5__/* .PageContainer */ ._, {
                containerClass: "container--faq-article",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atomic_Breadcrumbs__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumbs */ .O, {
                        breadcrumbs: breadcrumbs
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: article.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
                        article: article
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FaqsArticlePage);


/***/ }),

/***/ 96526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"breadcrumbs_list__7kiNO","has-max-width":"breadcrumbs_has-max-width__uFJVk","breadcrumb":"breadcrumbs_breadcrumb__WZiF_","breadcrumb-item":"breadcrumbs_breadcrumb-item__7nfbQ","phAnimation":"breadcrumbs_phAnimation__LRHHK"};

/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1852,5675,1967,264,638,1429,9774,2888,179], function() { return __webpack_exec__(9701); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);